package com.evoapps.evoshift.ui.user

import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import com.evoapps.evoshift.widgets.ErrorState
import com.evoapps.evoshift.widgets.ScrollableCentre
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.LocalActionFeedback
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import kotlinx.coroutines.launch
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.viewmodels.Gate
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Block
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import kotlinx.datetime.LocalDate
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.roster_open_shift_toggle
import evoshift.composeapp.generated.resources.requests_conflicts_unassigned
import evoshift.composeapp.generated.resources.confirm
import evoshift.composeapp.generated.resources.dashboard_all_caught_up
import evoshift.composeapp.generated.resources.marketplace
import evoshift.composeapp.generated.resources.nav_requests
import evoshift.composeapp.generated.resources.requests_absence_approved
import evoshift.composeapp.generated.resources.requests_absence_request
import evoshift.composeapp.generated.resources.requests_accepted
import evoshift.composeapp.generated.resources.requests_approve_absence
import evoshift.composeapp.generated.resources.requests_approve_absence_confirm
import evoshift.composeapp.generated.resources.requests_approve_swap
import evoshift.composeapp.generated.resources.requests_approve_swap_confirm
import evoshift.composeapp.generated.resources.requests_assigned_to
import evoshift.composeapp.generated.resources.requests_pending
import evoshift.composeapp.generated.resources.requests_reject_absence
import evoshift.composeapp.generated.resources.requests_reject_absence_confirm
import evoshift.composeapp.generated.resources.requests_reject_swap
import evoshift.composeapp.generated.resources.requests_reject_swap_confirm
import evoshift.composeapp.generated.resources.requests_swap_done
import evoshift.composeapp.generated.resources.requests_swap_request
import evoshift.composeapp.generated.resources.schedule_cant_work
import evoshift.composeapp.generated.resources.status_value
import evoshift.composeapp.generated.resources.unknown
import com.evoapps.evoshift.ui.util.label
import org.jetbrains.compose.resources.StringResource
import evoshift.composeapp.generated.resources.absences_action_approve
import evoshift.composeapp.generated.resources.absences_action_reject
import evoshift.composeapp.generated.resources.requests_approve_description
import evoshift.composeapp.generated.resources.requests_reject_description
import androidx.compose.foundation.BorderStroke
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import evoshift.composeapp.generated.resources.Res
import com.evoapps.evoshift.ui.adaptive.CentredBox
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyGridScope
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.grid.items as gridItems
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.Absence
import com.evoapps.evoshift.domain.model.AbsenceStatus
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.model.SwapStatus
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.viewmodels.AbsenceWithConflicts
import com.evoapps.evoshift.viewmodels.RequestsEvent
import com.evoapps.evoshift.viewmodels.RequestsViewModel
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.*
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun RequestsScreen(
    viewModel: RequestsViewModel,
    /** Null at a tab's root: back returns home there, no arrow. */
    onNavigateBack: (() -> Unit)?,
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    var confirmDialogState by remember { mutableStateOf<ConfirmDialogData?>(null) }
    val snackbarHostState = remember { SnackbarHostState() }
    // SH-158: a decision answers at once: a buzz (a confirming one for an approval, a tick for a
    // rejection) and a short line, while the card glides out of the list.
    val feedback = LocalActionFeedback.current
    val snackScope = rememberCoroutineScope()
    val approvedText = stringResource(Res.string.requests_decided_approved)
    val rejectedText = stringResource(Res.string.requests_decided_rejected)
    fun decided(approved: Boolean) {
        if (approved) feedback.confirm() else feedback.tick()
        snackScope.launch {
            snackbarHostState.currentSnackbarData?.dismiss()
            snackbarHostState.showSnackbar(if (approved) approvedText else rejectedText, duration = SnackbarDuration.Short)
        }
    }

    // SH-164: a one-tap approval: "Approved." with Undo (puts the request back as it was).
    state.undo?.let { undo ->
        val undoLabel = stringResource(Res.string.copy_undo)
        LaunchedEffect(undo) {
            snackbarHostState.currentSnackbarData?.dismiss()
            val result = snackbarHostState.showSnackbar(approvedText, actionLabel = undoLabel, withDismissAction = true, duration = SnackbarDuration.Long)
            viewModel.onEvent(if (result == SnackbarResult.ActionPerformed) RequestsEvent.UndoDecision else RequestsEvent.DismissUndo)
        }
    }
    val noticeText = state.notice?.asString()
    LaunchedEffect(noticeText) {
        noticeText?.let {
            snackbarHostState.currentSnackbarData?.dismiss()
            snackbarHostState.showSnackbar(it, duration = SnackbarDuration.Short)
            viewModel.onEvent(RequestsEvent.ClearNotice)
        }
    }

    // SH-164: a rejection asks first, with an optional reason the employee sees.
    var rejectDialog by remember { mutableStateOf<RejectDialogData?>(null) }
    rejectDialog?.let { data ->
        RejectReasonDialog(
            data = data,
            onConfirm = { reason ->
                data.onConfirm(reason)
                rejectDialog = null
                decided(approved = false)
            },
            onDismiss = { rejectDialog = null }
        )
    }

    // SH-223: an approval over a yearly limit: only with the manager's note why.
    state.overLimit?.let { over ->
        OverLimitDialog(
            over = over,
            onApprove = { note ->
                viewModel.onEvent(RequestsEvent.ApproveAbsence(over.absence, note))
                decided(approved = true)
            },
            onDismiss = { viewModel.onEvent(RequestsEvent.DismissOverLimit) }
        )
    }

    // A decision whose save failed is put back on the list; this says why.
    val errorText = state.error?.asString()
    LaunchedEffect(errorText) {
        errorText?.let {
            // Over the "Approved." of the decision that failed.
            snackbarHostState.currentSnackbarData?.dismiss()
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(RequestsEvent.ClearError)
        }
    }

    confirmDialogState?.let { data ->
        EvoConfirmDialog(
            title = stringResource(data.title),
            text = stringResource(data.message, *data.messageArgs.toTypedArray()),
            confirmLabel = if (data.isDangerous) stringResource(Res.string.confirm) else stringResource(Res.string.absences_action_approve),
            onConfirm = {
                data.onConfirm()
                confirmDialogState = null
            },
            onDismiss = { confirmDialogState = null },
            destructive = data.isDangerous,
            icon = if (data.isDangerous) Icons.Default.Block else Icons.Default.CheckCircle
        )
    }

    Scaffold(
        containerColor = Cream,
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.nav_requests),
                onBack = onNavigateBack,
                actions = listOf(helpAction(HelpPage.REQUESTS))
            )
        },
        snackbarHost = { SnackbarHost(snackbarHostState) }
    ) { padding ->
        val maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth
        // SH-168: pulling down reads the requests again.
        PullToRefreshBox(
            isRefreshing = state.isRefreshing,
            onRefresh = { viewModel.onEvent(RequestsEvent.Refresh) },
            modifier = Modifier.fillMaxSize().padding(padding)
        ) {
            val pendingAbsences = state.pendingAbsences
            val pendingSwaps = state.pendingSwaps
            val otherRequests = state.otherRequests
            val acceptedAbsences = otherRequests.filterIsInstance<Absence>().filter { it.status == AbsenceStatus.APPROVED }
            val acceptedSwaps = otherRequests.filterIsInstance<Shift>().filter { it.swapRequest == null && it.userDisplayName != null }

            // Read-only once the workplace's plan ended (SH-65): the requests, without decisions.
            val canDecide = state.capabilities.shows(Gate.DECIDE_REQUESTS)
            val absenceRequest: @Composable (AbsenceWithConflicts) -> Unit = { item ->
                RequestItem(
                    absence = item.absence,
                    conflicts = item.conflicts,
                    personName = state.names[item.absence.userId],
                    onApprove = {
                        if (item.conflicts.isEmpty()) {
                            // SH-164: nothing at stake: approved in one tap, with Undo in the snackbar.
                            viewModel.onEvent(RequestsEvent.ApproveAbsence(item.absence))
                            feedback.confirm()
                        } else {
                            // Shifts lose their person: the manager confirms that first.
                            confirmDialogState = ConfirmDialogData(
                                title = Res.string.requests_approve_absence,
                                message = Res.string.requests_approve_absence_confirm,
                                messageArgs = listOf(item.conflicts.size),
                                onConfirm = { viewModel.onEvent(RequestsEvent.ApproveAbsence(item.absence)); decided(approved = true) }
                            )
                        }
                    }.takeIf { canDecide },
                    onReject = {
                        rejectDialog = RejectDialogData(
                            title = Res.string.requests_reject_absence,
                            message = Res.string.requests_reject_absence_confirm,
                            onConfirm = { reason -> viewModel.onEvent(RequestsEvent.RejectAbsence(item.absence, reason)) }
                        )
                    }.takeIf { canDecide }
                )
            }
            // SH-223: remote work, work events and overtime: one tap either way (shifts stay).
            val workRequest: @Composable (com.evoapps.evoshift.viewmodels.WorkRequestWithConflicts) -> Unit = { item ->
                PendingWorkRequestItem(
                    item = item,
                    personName = state.names[item.request.userId],
                    onApprove = { viewModel.onEvent(RequestsEvent.ApproveWork(item.request)); decided(approved = true) }.takeIf { canDecide },
                    onReject = {
                        rejectDialog = RejectDialogData(
                            title = Res.string.requests_reject_absence,
                            message = Res.string.requests_reject_absence_confirm,
                            onConfirm = { reason -> viewModel.onEvent(RequestsEvent.RejectWork(item.request, reason)) }
                        )
                    }.takeIf { canDecide }
                )
            }
            val pendingWork = state.pendingWork
            val swapRequest: @Composable (Shift) -> Unit = { shift ->
                SwapRequestItem(
                    shift = shift,
                    onApprove = {
                        // SH-164: one tap, with Undo in the snackbar (the card says what it decides).
                        viewModel.onEvent(RequestsEvent.ApproveSwap(shift.id))
                        feedback.confirm()
                    }.takeIf { canDecide },
                    onReject = {
                        rejectDialog = RejectDialogData(
                            title = Res.string.requests_reject_swap,
                            message = Res.string.requests_reject_swap_confirm,
                            onConfirm = { reason -> viewModel.onEvent(RequestsEvent.RejectSwap(shift.id, reason)) }
                        )
                    }.takeIf { canDecide }
                )
            }

            val loadError = state.loadError
            val nothingShown = pendingAbsences.isEmpty() && pendingSwaps.isEmpty() && acceptedAbsences.isEmpty() && acceptedSwaps.isEmpty() && pendingWork.isEmpty()
            if (nothingShown && loadError != null) {
                // SH-168: the requests could not be read: not "all caught up", Try again.
                ErrorState(loadError, onRetry = { viewModel.onEvent(RequestsEvent.Refresh) })
            } else if (nothingShown && state.isLoading && !state.isRefreshing) {
                // SH-247: the requests are on their way: their cards' shapes, not "all caught up".
                CentredBox(maxWidth) { margin ->
                    com.evoapps.evoshift.widgets.SkeletonList(
                        Modifier.padding(horizontal = margin).padding(16.dp),
                        count = 4,
                        lines = 3
                    )
                }
            } else if (nothingShown) {
                ScrollableCentre(Modifier.padding(16.dp)) {
                    Text(stringResource(Res.string.dashboard_all_caught_up), color = DeepNavy.copy(alpha = 0.5f))
                }
            } else if (LocalWindowWidthClass.current.isExpanded) {
                // Wide windows: absences and shift swaps are separate kinds of decision, so each
                // gets its own column, pending first and the accepted ones below.
                // SH-130: the columns reach the screen's edges (the wheel scrolls them over the
                // empty sides too); their cards stay within the centred width.
                CentredBox(maxWidth) { margin ->
                    Row(
                        modifier = Modifier.fillMaxSize(),
                        horizontalArrangement = Arrangement.spacedBy(24.dp)
                    ) {
                        RequestsPane(
                            title = stringResource(Res.string.requests_absences_column),
                            horizontalPadding = PaddingValues(start = margin + 16.dp),
                            pendingCount = pendingAbsences.size + pendingWork.size,
                            isEmpty = pendingAbsences.isEmpty() && acceptedAbsences.isEmpty() && pendingWork.isEmpty(),
                            modifier = Modifier.weight(1f)
                        ) {
                            // SH-158: stable keys (prefixed: one request can briefly be in two lists)
                            // so a decided card glides out and the others close up.
                            items(pendingAbsences, key = { "pa-${it.absence.id}" }) { Box(Modifier.animateItemIfMotion(this)) { absenceRequest(it) } }
                            items(pendingWork, key = { "pw-${it.request.id}" }) { Box(Modifier.animateItemIfMotion(this)) { workRequest(it) } }
                            if (acceptedAbsences.isNotEmpty()) {
                                item(key = "accepted-absences") { RequestsSubheader(stringResource(Res.string.requests_accepted)) }
                                items(acceptedAbsences, key = { "aa-${it.id}" }) { Box(Modifier.animateItemIfMotion(this)) { AcceptedAbsenceItem(it) } }
                            }
                        }
                        RequestsPane(
                            title = stringResource(Res.string.requests_swaps_column),
                            horizontalPadding = PaddingValues(end = margin + 16.dp),
                            pendingCount = pendingSwaps.size,
                            isEmpty = pendingSwaps.isEmpty() && acceptedSwaps.isEmpty(),
                            modifier = Modifier.weight(1f)
                        ) {
                            items(pendingSwaps, key = { "ps-${it.id}" }) { Box(Modifier.animateItemIfMotion(this)) { swapRequest(it) } }
                            if (acceptedSwaps.isNotEmpty()) {
                                item(key = "accepted-swaps") { RequestsSubheader(stringResource(Res.string.requests_accepted)) }
                                items(acceptedSwaps, key = { "as-${it.id}" }) { Box(Modifier.animateItemIfMotion(this)) { AcceptedSwapItem(it) } }
                            }
                        }
                    }
                }
            } else {
                // Phones: the single list as before; small tablets: two columns of cards.
                AdaptiveCardGrid(
                    modifier = Modifier.fillMaxSize(),
                    contentPadding = PaddingValues(16.dp),
                    maxWidth = maxWidth
                ) {
                    if (pendingAbsences.isNotEmpty() || pendingSwaps.isNotEmpty() || pendingWork.isNotEmpty()) {
                        fullWidthItem {
                            Text(
                                text = stringResource(Res.string.requests_pending),
                                style = MaterialTheme.typography.titleMedium,
                                fontWeight = FontWeight.Bold,
                                color = DeepNavy,
                                modifier = Modifier.padding(vertical = 8.dp)
                            )
                        }
                        // SH-158: stable keys (prefixed: one request can briefly be in two lists)
                        // so a decided card glides out and the others close up.
                        gridItems(pendingAbsences, key = { "pa-${it.absence.id}" }) { Box(Modifier.animateItemIfMotion(this)) { absenceRequest(it) } }
                        gridItems(pendingWork, key = { "pw-${it.request.id}" }) { Box(Modifier.animateItemIfMotion(this)) { workRequest(it) } }
                        gridItems(pendingSwaps, key = { "ps-${it.id}" }) { Box(Modifier.animateItemIfMotion(this)) { swapRequest(it) } }
                    }

                    if (acceptedAbsences.isNotEmpty() || acceptedSwaps.isNotEmpty()) {
                        fullWidthItem {
                            Text(
                                text = stringResource(Res.string.requests_accepted),
                                style = MaterialTheme.typography.titleMedium,
                                fontWeight = FontWeight.Bold,
                                color = DeepNavy,
                                modifier = Modifier.padding(top = 16.dp, bottom = 8.dp)
                            )
                        }
                        gridItems(acceptedAbsences, key = { "aa-${it.id}" }) { Box(Modifier.animateItemIfMotion(this)) { AcceptedAbsenceItem(it) } }
                        gridItems(acceptedSwaps, key = { "as-${it.id}" }) { Box(Modifier.animateItemIfMotion(this)) { AcceptedSwapItem(it) } }
                    }
                }
            }

            // Refreshes keep the list on screen; SH-247: the first load shows the placeholders (no spinner).

        }
    }
}

/** A grid row of its own: section headers span every column. */
private fun LazyGridScope.fullWidthItem(content: @Composable () -> Unit) {
    item(span = { GridItemSpan(maxLineSpan) }) { content() }
}

/** One column of the wide Requests layout: a heading with the pending count over its own list. */
@Composable
private fun RequestsPane(
    title: String,
    pendingCount: Int,
    isEmpty: Boolean,
    modifier: Modifier = Modifier,
    /** Only the start and end of it count: the side of the screen this column reaches to. */
    horizontalPadding: PaddingValues = PaddingValues(0.dp),
    content: LazyListScope.() -> Unit
) {
    val direction = LocalLayoutDirection.current
    LazyColumn(
        modifier = modifier.fillMaxHeight(),
        verticalArrangement = Arrangement.spacedBy(12.dp),
        contentPadding = PaddingValues(
            start = horizontalPadding.calculateStartPadding(direction),
            end = horizontalPadding.calculateEndPadding(direction),
            top = 16.dp,
            bottom = 16.dp
        )
    ) {
        item {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.padding(vertical = 8.dp)
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
                if (pendingCount > 0) {
                    Spacer(Modifier.width(8.dp))
                    Badge(containerColor = DarkGold, contentColor = DeepNavy) {
                        Text(pendingCount.toString(), fontWeight = FontWeight.Bold)
                    }
                }
            }
        }
        if (isEmpty) {
            item {
                Text(
                    stringResource(Res.string.dashboard_all_caught_up),
                    style = MaterialTheme.typography.bodyMedium,
                    color = DeepNavy.copy(alpha = 0.5f),
                    modifier = Modifier.padding(vertical = 8.dp)
                )
            }
        }
        content()
    }
}

@Composable
private fun RequestsSubheader(text: String) {
    Text(
        text = text,
        style = MaterialTheme.typography.titleSmall,
        fontWeight = FontWeight.Bold,
        color = DeepNavy.copy(alpha = 0.7f),
        modifier = Modifier.padding(top = 16.dp, bottom = 4.dp)
    )
}

@Composable
fun SwapRequestItem(
    shift: Shift,
    /** Null: read-only, no decision buttons. */
    onApprove: (() -> Unit)?,
    onReject: (() -> Unit)?
) {
    val request = shift.swapRequest ?: return
    val who = shift.userDisplayName ?: request.initiatorName.ifBlank { stringResource(Res.string.unknown) }
    val what = "${dayAndDate(LocalDate.parse(shift.date))}, ${shift.plannedTime.start.substringAfter('T').take(5)}–${shift.plannedTime.end.substringAfter('T').take(5)}"
    val approveDescription = stringResource(Res.string.requests_approve_description, who, what)
    val rejectDescription = stringResource(Res.string.requests_reject_description, who, what)
    val wide = decisionsLabelled

    RegularCard(modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Top
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = if (request.status == SwapStatus.REQUESTED_BY_OWNER) 
                            stringResource(Res.string.schedule_cant_work) 
                        else 
                            stringResource(Res.string.requests_swap_request),
                        style = MaterialTheme.typography.labelSmall,
                        color = DarkGold,
                        fontWeight = FontWeight.Bold
                    )
                    Text(
                        text = "${if (shift.userId == null) stringResource(Res.string.roster_open_shift_toggle) else shift.userDisplayName ?: request.initiatorName.ifBlank { stringResource(Res.string.unknown) }} » ${request.candidateName ?: stringResource(Res.string.marketplace)}",
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = DeepNavy
                    )
                    Text(
                        text = "${dayAndDate(LocalDate.parse(shift.date))}, ${shift.plannedTime.start.substringAfter('T').take(5)}–${shift.plannedTime.end.substringAfter('T').take(5)}",
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.6f)
                    )

                    // SH-165: the employee's own note on the request.
                    request.initiatorNote?.takeIf { it.isNotBlank() }?.let { own ->
                        Spacer(Modifier.height(8.dp))
                        Text(
                            text = stringResource(Res.string.swap_note_value, own),
                            style = MaterialTheme.typography.bodyMedium,
                            color = DeepNavy.copy(alpha = 0.8f)
                        )
                    }
                    val note = request.managerNote
                    if (!note.isNullOrBlank()) {
                        Spacer(Modifier.height(8.dp))
                        Text(
                            text = note,
                            style = MaterialTheme.typography.bodyMedium,
                            color = DeepNavy.copy(alpha = 0.8f)
                        )
                    }

                    Spacer(Modifier.height(4.dp))
                    Surface(
                        color = DarkGold.copy(alpha = 0.1f),
                        shape = MaterialTheme.shapes.extraSmall
                    ) {
                        Text(
                            text = stringResource(Res.string.status_value, request.status.label()),
                            modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp),
                            style = MaterialTheme.typography.labelSmall,
                            color = DarkGold,
                            fontWeight = FontWeight.Bold
                        )
                    }
                }

                if (onApprove != null && onReject != null && !wide) Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                    RejectIconButton(onReject, rejectDescription)
                    ApproveTextButton(onApprove, approveDescription)
                }
            }
            if (onApprove != null && onReject != null && wide) WideDecisionButtons(onApprove, onReject, approveDescription, rejectDescription)
        }
    }
}

/**
 * SH-163: "Reject" as an icon on a phone; its description says whose request it rejects
 * ("Odrzuć wniosek: Jan Kowalski (…)") for screen readers.
 */
@Composable
private fun RejectIconButton(onReject: () -> Unit, description: String) {
    FilledIconButton(
        onClick = onReject,
        colors = IconButtonDefaults.filledIconButtonColors(containerColor = Color.Red.copy(alpha = 0.1f), contentColor = Color.Red)
    ) {
        Icon(Icons.Default.Close, contentDescription = description)
    }
}

/** "Approve" with its icon; its description says whose request it approves (SH-163). */
@Composable
private fun ApproveTextButton(onApprove: () -> Unit, description: String) {
    Button(
        onClick = onApprove,
        colors = ButtonDefaults.buttonColors(containerColor = DarkGold, contentColor = DeepNavy),
        contentPadding = PaddingValues(horizontal = 16.dp),
        modifier = Modifier.semantics { contentDescription = description }
    ) {
        Icon(Icons.Default.Check, contentDescription = null, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(8.dp))
        Text(stringResource(Res.string.absences_action_approve), style = MaterialTheme.typography.labelLarge)
    }
}

/**
 * SH-163: on wide windows both decisions are labelled buttons ("Reject", "Approve") in a row under
 * the request, like the swap card's approve button; their descriptions name the request.
 */
@Composable
private fun WideDecisionButtons(onApprove: () -> Unit, onReject: () -> Unit, approveDescription: String, rejectDescription: String) {
    Spacer(Modifier.height(12.dp))
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End),
        verticalAlignment = Alignment.CenterVertically
    ) {
        OutlinedButton(
            onClick = onReject,
            colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.Red),
            border = BorderStroke(1.dp, Color.Red.copy(alpha = 0.4f)),
            modifier = Modifier.semantics { contentDescription = rejectDescription }
        ) {
            Icon(Icons.Default.Close, contentDescription = null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Text(stringResource(Res.string.absences_action_reject), style = MaterialTheme.typography.labelLarge)
        }
        ApproveTextButton(onApprove, approveDescription)
    }
}

/** SH-163: the cards' decision buttons show their labels on everything wider than a phone. */
private val decisionsLabelled: Boolean
    @Composable get() = !LocalWindowWidthClass.current.isCompact

@Composable
fun AcceptedSwapItem(shift: Shift) {
    RegularCard(
        modifier = Modifier.fillMaxWidth().alpha(0.6f)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = stringResource(Res.string.requests_swap_done),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Gray,
                        fontWeight = FontWeight.Bold
                    )
                    Text(
                        text = stringResource(Res.string.requests_assigned_to, shift.userDisplayName ?: ""),
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = DeepNavy.copy(alpha = 0.7f)
                    )
                    Text(
                        text = "${dayAndDate(LocalDate.parse(shift.date))}, ${shift.plannedTime.start.substringAfter('T').take(5)}–${shift.plannedTime.end.substringAfter('T').take(5)}",
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.5f)
                    )
                }

                Icon(
                    Icons.Default.Check,
                    contentDescription = null,
                    tint = Color(0xFF4CAF50),
                    modifier = Modifier.size(24.dp)
                )
            }
        }
    }
}

@Composable
fun AcceptedAbsenceItem(absence: Absence) {
    RegularCard(
        modifier = Modifier.fillMaxWidth().alpha(0.6f)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = stringResource(Res.string.requests_absence_approved),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Gray,
                        fontWeight = FontWeight.Bold
                    )
                    Text(
                        text = absence.type.label(),
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = DeepNavy.copy(alpha = 0.7f)
                    )
                    Text(
                        text = absencePeriod(absence),
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.5f)
                    )
                }
                
                Icon(
                    Icons.Default.Check,
                    contentDescription = null,
                    tint = Color(0xFF4CAF50),
                    modifier = Modifier.size(24.dp)
                )
            }
        }
    }
}

data class ConfirmDialogData(
    val title: StringResource,
    val message: StringResource,
    val onConfirm: () -> Unit,
    val messageArgs: List<Any> = emptyList(),
    val isDangerous: Boolean = false
)

/** SH-164: a rejection to confirm; [onConfirm] gets the optional reason as typed (blank: none). */
data class RejectDialogData(
    val title: StringResource,
    val message: StringResource,
    val onConfirm: (reason: String) -> Unit
)

/** Test tag of the rejection's reason field. */
const val REJECT_REASON_TEST_TAG = "requests_reject_reason"

/**
 * SH-164: "Reject …?" with an optional reason ("Reason (optional)"), which the employee sees on
 * their request or shift and in the notification.
 */
@Composable
fun RejectReasonDialog(data: RejectDialogData, onConfirm: (String) -> Unit, onDismiss: () -> Unit) {
    var reason by rememberSaveable { mutableStateOf("") }
    com.evoapps.evoshift.widgets.EvoDialog(
        title = stringResource(data.title),
        onDismiss = onDismiss,
        icon = Icons.Default.Block,
        destructive = true,
        width = com.evoapps.evoshift.widgets.DialogWidth.Compact,
        confirm = com.evoapps.evoshift.widgets.DialogAction(stringResource(Res.string.absences_action_reject), { onConfirm(reason) }),
        dismiss = com.evoapps.evoshift.widgets.DialogAction(stringResource(Res.string.cancel), onDismiss)
    ) {
        Text(stringResource(data.message), style = MaterialTheme.typography.bodyLarge, color = Color.White.copy(alpha = 0.85f))
        com.evoapps.evoshift.widgets.EvoTextField(
            value = reason,
            onValueChange = { reason = it.take(com.evoapps.evoshift.viewmodels.REJECTION_REASON_MAX_LENGTH) },
            label = stringResource(Res.string.requests_reject_reason_label),
            supportingText = stringResource(Res.string.requests_reject_reason_hint),
            singleLine = false,
            minLines = 2,
            imeAction = androidx.compose.ui.text.input.ImeAction.Default,
            modifier = Modifier.fillMaxWidth().testTag(REJECT_REASON_TEST_TAG)
        )
    }
}

@Composable
fun RequestItem(
    absence: Absence,
    conflicts: List<Shift>,
    /** Null: read-only, no decision buttons. */
    onApprove: (() -> Unit)?,
    onReject: (() -> Unit)?,
    /** SH-163: whose request it is (null: not known). */
    personName: String? = null
) {
    val who = personName ?: stringResource(Res.string.unknown)
    val what = "${absence.type.label()}, ${absencePeriod(absence)}"
    val approveDescription = stringResource(Res.string.requests_approve_description, who, what)
    val rejectDescription = stringResource(Res.string.requests_reject_description, who, what)
    val wide = decisionsLabelled
    RegularCard(modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Top
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = stringResource(Res.string.requests_absence_request),
                        style = MaterialTheme.typography.labelSmall,
                        color = DarkGold,
                        fontWeight = FontWeight.Bold
                    )
                    // SH-163: whose request it is.
                    if (personName != null) {
                        Text(
                            text = personName,
                            style = MaterialTheme.typography.titleMedium,
                            fontWeight = FontWeight.Bold,
                            color = DeepNavy
                        )
                    }
                    Text(
                        text = absence.type.label(),
                        style = if (personName != null) MaterialTheme.typography.bodyMedium else MaterialTheme.typography.titleMedium,
                        fontWeight = if (personName != null) FontWeight.SemiBold else FontWeight.Bold,
                        color = DeepNavy
                    )
                    Text(
                        text = absencePeriod(absence),
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.6f)
                    )
                    AbsenceDetailsLines(absence, DeepNavy.copy(alpha = 0.7f))
                    
                    val reason = absence.reason
                    if (!reason.isNullOrBlank()) {
                        Spacer(Modifier.height(8.dp))
                        Text(
                            text = reason,
                            style = MaterialTheme.typography.bodyMedium,
                            color = DeepNavy.copy(alpha = 0.8f)
                        )
                    }

                    if (conflicts.isNotEmpty()) {
                        Spacer(Modifier.height(12.dp))
                        Surface(
                            color = Color.Red.copy(alpha = 0.1f),
                            shape = MaterialTheme.shapes.small
                        ) {
                            Row(
                                modifier = Modifier.padding(8.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Icon(
                                    Icons.Default.Close,
                                    contentDescription = null,
                                    tint = Color.Red,
                                    modifier = Modifier.size(16.dp)
                                )
                                Spacer(Modifier.width(8.dp))
                                Text(
                                    text = stringResource(Res.string.requests_conflicts_unassigned, conflicts.size),
                                    style = MaterialTheme.typography.bodySmall,
                                    color = Color.Red,
                                    fontWeight = FontWeight.Bold
                                )
                            }
                        }
                    }
                }
                
                if (onApprove != null && onReject != null && !wide) Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    RejectIconButton(onReject, rejectDescription)
                    FilledIconButton(
                        onClick = onApprove,
                        colors = IconButtonDefaults.filledIconButtonColors(containerColor = DarkGold, contentColor = DeepNavy)
                    ) {
                        Icon(Icons.Default.Check, contentDescription = approveDescription)
                    }
                }
            }
            if (onApprove != null && onReject != null && wide) WideDecisionButtons(onApprove, onReject, approveDescription, rejectDescription)
        }
    }
}


/**
 * SH-223: "Approve over the limit?": what is left and what is asked for, and the note the
 * approval needs (it is stored on the request and shown with it).
 */
@Composable
fun OverLimitDialog(over: com.evoapps.evoshift.viewmodels.OverLimitApproval, onApprove: (String) -> Unit, onDismiss: () -> Unit) {
    var note by rememberSaveable { mutableStateOf("") }
    val counter = over.check.counter
    val unitText: (Double) -> String = { value ->
        if (counter.unit == com.evoapps.evoshift.domain.model.LimitUnit.HOURS) "${amountText(value)} h" else amountText(value)
    }
    com.evoapps.evoshift.widgets.EvoDialog(
        title = stringResource(Res.string.requests_override_title),
        onDismiss = onDismiss,
        icon = Icons.Default.CheckCircle,
        width = com.evoapps.evoshift.widgets.DialogWidth.Compact,
        confirm = com.evoapps.evoshift.widgets.DialogAction(stringResource(Res.string.requests_override_approve), {
            if (note.isNotBlank()) onApprove(note.trim())
        })
    ) {
        Text(
            stringResource(Res.string.requests_override_text, unitText(counter.remainingApproved), unitText(over.check.requested)),
            style = MaterialTheme.typography.bodyLarge, color = Color.White.copy(alpha = 0.85f)
        )
        com.evoapps.evoshift.widgets.EvoTextField(
            value = note,
            onValueChange = { note = it.take(com.evoapps.evoshift.viewmodels.REJECTION_REASON_MAX_LENGTH) },
            label = stringResource(Res.string.requests_override_note),
            singleLine = false,
            minLines = 2,
            imeAction = androidx.compose.ui.text.input.ImeAction.Default,
            modifier = Modifier.fillMaxWidth().testTag(OVERRIDE_NOTE_TEST_TAG)
        )
    }
}

/** Test tag of the over-limit note field. */
const val OVERRIDE_NOTE_TEST_TAG = "requests_override_note"

/** SH-223: a pending remote-work, work-event or overtime request: whose, what, when, where; a work event's clashing shifts. */
@Composable
fun PendingWorkRequestItem(
    item: com.evoapps.evoshift.viewmodels.WorkRequestWithConflicts,
    personName: String?,
    onApprove: (() -> Unit)?,
    onReject: (() -> Unit)?
) {
    val request = item.request
    val who = personName ?: stringResource(Res.string.unknown)
    val what = "${request.kind.label()}, ${workPeriod(request)}"
    val approveDescription = stringResource(Res.string.requests_approve_description, who, what)
    val rejectDescription = stringResource(Res.string.requests_reject_description, who, what)
    val wide = decisionsLabelled
    RegularCard(modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.Top) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(stringResource(Res.string.requests_work_request), style = MaterialTheme.typography.labelSmall, color = DarkGold, fontWeight = FontWeight.Bold)
                    if (personName != null) Text(personName, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = DeepNavy)
                    Text(request.kind.label(), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.SemiBold, color = DeepNavy)
                    Text(workPeriod(request), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.6f))
                    request.placeName?.let { Text(it, style = MaterialTheme.typography.bodyMedium, color = DeepNavy.copy(alpha = 0.8f)) }
                    request.note?.takeIf { it.isNotBlank() }?.let {
                        Spacer(Modifier.height(8.dp))
                        Text(it, style = MaterialTheme.typography.bodyMedium, color = DeepNavy.copy(alpha = 0.8f))
                    }
                    if (item.conflicts.isNotEmpty()) {
                        Spacer(Modifier.height(8.dp))
                        Text(stringResource(Res.string.requests_event_clashes, item.conflicts.size), style = MaterialTheme.typography.bodySmall,
                            color = Color(0xFF8A5A00), fontWeight = FontWeight.Bold)
                    }
                }
                if (onApprove != null && onReject != null && !wide) Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    RejectIconButton(onReject, rejectDescription)
                    FilledIconButton(onClick = onApprove, colors = IconButtonDefaults.filledIconButtonColors(containerColor = DarkGold, contentColor = DeepNavy)) {
                        Icon(Icons.Default.Check, contentDescription = approveDescription)
                    }
                }
            }
            if (onApprove != null && onReject != null && wide) WideDecisionButtons(onApprove, onReject, approveDescription, rejectDescription)
        }
    }
}
